/**
 * AC Volt Drop Calculator - Data & constants
 * BS 7671 reference values (mV/A/m)
 */

// Cable types for volt drop (AC radial circuits)
export const CABLE_TYPE_OPTIONS = [
  { id: '', label: 'Select', value: '' },
  { id: 'cu-flat-twin', label: 'Cu - Flat Twin & Earth', value: 'cu-flat-twin', maxSize: 16 },
  { id: 'cu-swa-70', label: 'Cu - SWA Multicore 70°C', value: 'cu-swa-70' },
  { id: 'cu-swa-90', label: 'Cu - SWA Multicore 90°C', value: 'cu-swa-90' },
  {
    id: 'cu-single-70',
    label: 'Cu - Single-core 70°C - In Trunking or Conduit',
    value: 'cu-single-70',
  },
  {
    id: 'h07rn-f',
    label: 'H07RN-F Multicore 60°C (Table 4F1B)',
    value: 'h07rn-f',
  },
];

// Cable sizes (mm²) - Flat Twin & Earth limited to max 16mm
export const CABLE_SIZES = [
  1.5, 2.5, 4, 6, 10, 16, 25, 35, 50, 70, 95, 120, 150, 185, 240, 300, 400,
];

// Phase options
export const PHASE_OPTIONS = [
  { id: '', label: 'Select', value: '' },
  { id: 'single', label: '2 Core - Single Phase', value: 'single' },
  { id: 'three', label: '3 or 4 Core - Three Phase', value: 'three' },
];

// mV/A/m lookup: { cableType: { size: { single: mV, three: mV } } }
// BS 7671 Tables 4D2B (Flat T&E), 4D4B (SWA 70°C), 4E2B (SWA 90°C), 4D1B (Single-core), 4F1B (H07RN-F)
const MV_AM_M_SINGLE = {
  1.5: 29,
  2.5: 18,
  4: 11,
  6: 7.3,
  10: 4.4,
  16: 2.8,
  25: 1.75,
  35: 1.25,
  50: 0.93,
  70: 0.63,
  95: 0.47,
  120: 0.39,
  150: 0.32,
  185: 0.27,
  240: 0.21,
  300: 0.17,
  400: 0.13,
};

// Three-phase values (typically ~0.87 × single for multicore)
const MV_AM_THREE = {
  1.5: 25,
  2.5: 15,
  4: 9.5,
  6: 6.4,
  10: 3.8,
  16: 2.4,
  25: 1.5,
  35: 1.1,
  50: 0.81,
  70: 0.55,
  95: 0.41,
  120: 0.34,
  150: 0.28,
  185: 0.23,
  240: 0.18,
  300: 0.15,
  400: 0.11,
};

export function getMvPerAmPerM(cableType, cableSize, phase) {
  if (!cableType || !cableSize || !phase) return null;
  const size = parseFloat(cableSize);
  const vals = phase === 'single' ? MV_AM_SINGLE : MV_AM_THREE;
  return vals[size] ?? null;
}

export function getCableSizesForType(cableType) {
  const typeOpt = CABLE_TYPE_OPTIONS.find((o) => o.value === cableType);
  const maxSize = typeOpt?.maxSize;
  if (maxSize) {
    return CABLE_SIZES.filter((s) => s <= maxSize);
  }
  return [...CABLE_SIZES];
}
